import { getToken } from "../../helper/common";
import agent from "../services/agent";
import {
  SET_REQUESTS_LIST,
  SET_INITIAL_STATE,
  SET_REQUESTS_PENDING,
  REQUESTS_LIST_ERROR,
} from "../requests/actionTypes";
import { showSnackbarStatus } from "../snackbar/actions";
// import { showSnackbarStatus } from "./snackbar.actions";

export const setRequestActionFormInitialState = () => ({
  type: SET_INITIAL_STATE,
});

export const setRequestsPending = () => ({
  type: SET_REQUESTS_PENDING,
});

const setRequestsList = (requestsOdata) => ({
  type: SET_REQUESTS_LIST,
  payload: { requestsOdata },
});

const requestsListError = (errorMessage) => ({
  type: REQUESTS_LIST_ERROR,
  payload: { errorMessage },
});

export const getRequestsList = (page, pageSize, sortDirection, sortOrder) => (dispatch) => {
  dispatch(setRequestsPending());
  getToken(dispatch).then((accessToken) => {
    agent.Request.getRequests(accessToken, page, pageSize, sortDirection, sortOrder)
      .then((requestList) => {
        dispatch(setRequestsList(requestList));
      })
      .catch((err) => {
        console.log("getRequests server error", err);
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(requestsListError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(requestsListError(message));
        }
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};
